import * as React from "react";
import type { SVGProps } from "react";
const SvgCircleClose = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M9.702 8.641a.75.75 0 1 0-1.06 1.061L10.938 12l-2.298 2.298a.75.75 0 0 0 1.06 1.061L12 13.061l2.298 2.298a.75.75 0 0 0 1.06-1.06L13.062 12l2.298-2.298a.75.75 0 0 0-1.06-1.06L12 10.94z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-1.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCircleClose;
